import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export const RestaurantSearch = ({ onSearch }: { onSearch: (query: string) => void }) => {
  return (
    <div className="w-full">
      <div className="relative">
        <Input
          type="text"
          placeholder="Search venues..."
          className="w-full pl-9 h-9 rounded-full bg-muted/50 border-border/40 focus:border-secondary/40 text-foreground placeholder:text-muted-foreground text-sm"
          onChange={(e) => onSearch(e.target.value)}
        />
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" />
      </div>
    </div>
  );
};
